/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'match-adder';
const prefix = `${moduleName}.${componentName}`;

export const matchLabel = `${prefix}.matchLabel`;
export const noEntriesLabel = `${prefix}.noEntriesLabel`;
export const noAvailableMatchesLabel = `${prefix}.noAvailableMatchesLabel`;

export const ENGLISH = {
    [matchLabel]: 'Match ({0})',
    [noEntriesLabel]: 'No entries have been added',
    [noAvailableMatchesLabel]: 'No available matches to add',
};
